"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
    i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    default: mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
var perfect_scrollbar_1 = __importDefault(require("perfect-scrollbar"));
var Select = function (_super) {
  __extends(Select, _super);
  function Select(props) {
    var _this = _super.call(this, props) || this;
    _this.tryFoldListener = function (e) {
      if (_this.container && !_this.container.contains(e.target)) {
        _this.setState({
          unfolded: false
        });
      }
    };
    _this.switchFold = function () {
      _this.setState({
        unfolded: !_this.state.unfolded
      });
    };
    _this.setContainer = function (ref) {
      if (!ref) {
        return;
      }
      _this.container = ref;
    };
    _this.renderOption = function (option) {
      return option.component ? option.component : option.text;
    };
    _this.setRef = function (ref) {
      if (ref) {
        _this.ps = new perfect_scrollbar_1.default(ref, {
          suppressScrollX: true
        });
      }
    };
    _this.state = {
      unfolded: false
    };
    return _this;
  }
  Select.prototype.componentDidMount = function () {
    window.document.addEventListener("mouseup", this.tryFoldListener);
  };
  Select.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.options !== prevProps.options) {
      this.ps.update();
    }
  };
  Select.prototype.componentWillUnmount = function () {
    window.document.removeEventListener("mouseup", this.tryFoldListener);
  };
  Select.prototype.getDropdownDirection = function () {
    if (!this.container) {
      return "down";
    }
    var topDistance = function topDistance(elem) {
      var location = 0;
      if (elem.offsetParent) {
        do {
          location += elem.offsetTop;
          elem = elem.offsetParent;
        } while (elem);
      }
      return location >= 0 ? location : 0;
    };
    var bottomDistance = window.innerHeight - topDistance(this.container) - this.container.offsetHeight;
    return bottomDistance < 200 ? "up" : "down";
  };
  Select.prototype.renderDropdown = function () {
    var _this = this;
    var e_1, _a;
    var _b = this.props,
      options = _b.options,
      onSelect = _b.onSelect,
      footer = _b.footer;
    var items = [];
    var _loop_1 = function _loop_1(option) {
      if (option.hidden) {
        return "continue";
      }
      items.push(React.createElement("div", {
        key: option.value,
        className: "RainConnect-item",
        onClick: function onClick(e) {
          if (option.disabled) {
            return;
          }
          if (onSelect) {
            onSelect(option, e);
          }
          if (option.onSelect) {
            option.onSelect(option, e);
          }
          if (onSelect || option.onSelect) {
            _this.setState({
              unfolded: false
            });
          }
        }
      }, this_1.renderOption(option)));
    };
    var this_1 = this;
    try {
      for (var options_1 = __values(options), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
        var option = options_1_1.value;
        _loop_1(option);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (options_1_1 && !options_1_1.done && (_a = options_1.return)) _a.call(options_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    var dropdownClassNames = ["RainConnect-dropdown"];
    var direction = this.getDropdownDirection();
    if (direction === "down") {
      dropdownClassNames.push("down");
    } else if (direction === "up") {
      dropdownClassNames.push("up");
    }
    return React.createElement("div", {
      className: dropdownClassNames.join(" "),
      ref: this.setRef
    }, items, footer && React.createElement("div", {
      className: "RainConnect-selectFooter"
    }, footer));
  };
  Select.prototype.renderSelected = function () {
    var _this = this;
    var e_2, _a;
    var selectOption;
    var _b = this.props,
      options = _b.options,
      selected = _b.selected,
      formatSelect = _b.formatSelect,
      noCaret = _b.noCaret,
      blank = _b.blank,
      disabled = _b.disabled;
    try {
      for (var options_2 = __values(options), options_2_1 = options_2.next(); !options_2_1.done; options_2_1 = options_2.next()) {
        var option = options_2_1.value;
        if (selected === option.value) {
          selectOption = option;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (options_2_1 && !options_2_1.done && (_a = options_2.return)) _a.call(options_2);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return React.createElement("div", {
      className: "RainConnect-selected",
      onClick: function onClick() {
        if (!disabled) {
          _this.switchFold();
        }
      }
    }, selectOption ? formatSelect ? formatSelect(selectOption) : this.renderOption(selectOption) : blank, noCaret ? null : this.renderCaret());
  };
  Select.prototype.renderCaret = function () {
    return React.createElement("div", {
      className: "RainConnect-caret"
    });
  };
  Select.prototype.render = function () {
    var unfolded = this.state.unfolded;
    var classNames = ["RainConnect-select"];
    if (unfolded) {
      classNames.push("RainConnect-unfolded");
    }
    return React.createElement("div", {
      className: classNames.join(" "),
      ref: this.setContainer
    }, this.renderSelected(), this.renderDropdown());
  };
  return Select;
}(React.PureComponent);
exports.default = Select;